export interface ListResponse<T> {
  items: Array<T>;
  total: number;
}
